import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const handled = useRef(false);

    useEffect(() => {
        if (handled.current) return;
        handled.current = true;
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(m[1]);
        (async () => {
            try {
                const res = await http.post("/auth/session", {
                    session_id: sessionId,
                });
                setUser(res.data.user);
                window.history.replaceState({}, "", "/");
                navigate("/", { replace: true });
            } catch (err) {
                toast.error(
                    err?.response?.data?.detail ||
                        "No se pudo completar la autenticación",
                );
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="h-screen flex flex-col items-center justify-center gap-3">
            <div className="tracing-beam w-56 h-1 bg-slate-200" />
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500">
                Validando sesión…
            </div>
        </div>
    );
}
